import { BitfODataPathBuilder } from '@bitf/core/parsers/odata-parser';

export class AppPathBuilder extends BitfODataPathBuilder {
  constructor() {
    super();
  }
}
